/**
 * Força URL absoluta do Web App Manifest.
 * Com BASE_URL relativo ou em rotas profundas do Vue, href relativo quebra o fetch
 * (o browser pede HTML da SPA → "Manifest: Line 1, column 1, Syntax error").
 */
export function applyPwaManifestHref() {
  if (typeof document === 'undefined' || typeof window === 'undefined') return
  const link = document.querySelector('link[rel="manifest"]')
  if (!link) return
  try {
    const base = new URL(import.meta.env.BASE_URL || '/', window.location.origin)
    const url = new URL('api/branding/pwa-manifest', base)
    url.searchParams.set('v', String(Date.now()))
    link.setAttribute('href', url.href)
  } catch {
    /* ignore */
  }
}

applyPwaManifestHref()
